import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DeleteElynkPacketRequest, DeleteElynkPacketResponse, GetElynkPacketsRequest, GetElynkPacketsResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { ELynkPacket, ELynkPacketAdd, ELynkPacketChecklist } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';
import { ActionService } from 'src/app/services/actions/action.service';

@Component({
    selector: 'app-elynk-packet-select',
    templateUrl: './elynk-packet-select.component.html',
    styleUrls: ['./elynk-packet-select.component.scss']
})
export class ElynkPacketSelectComponent extends DocumentTypeBaseComponent implements OnChanges {
    constructor(
        public actionService: ActionService,
        public configurationService: ConfigurationService



    ) {
        super(configurationService, actionService);
    }


    _selectedPacket: ELynkPacket = {
        id: null,
        add: null,
        checklist: null
    } as ELynkPacket;

    get selectedPacket() {
        return this._selectedPacket;
    }
    set selectedPacket(value: ELynkPacket) {
        this._selectedPacket = value
    }

    rowSelectedPacket: ELynkPacket;

    @Input() documentTypeId: number = 0;
    @Input() active: boolean = false;

    packets: ELynkPacket[] = [];
    newPacketId: string = "";


    async ngOnChanges(changes: SimpleChanges) {
        this.packets = (isNaN(this.documentTypeId) || +this.documentTypeId === 0) ? [] : await this.getPackets(this.documentTypeId);

        if (this.packets?.length > 0) {
            this.selectedPacket = this.packets[0];
            this.rowSelectedPacket = this.packets[0];
        } else {
            this.selectedPacket = (this.documentTypeId > 0) ? new ELynkPacket() : this.newPacket;
        }
    }

    packetChecklistChecked(event: any, packet: ELynkPacket) {
        if (event.checked) {
            packet.checklist ??= new ELynkPacketChecklist();
        } else {
            packet.checklist = null;
        }
        this._selectedPacket = JSON.parse(JSON.stringify(packet));
    }

    packetAddChecked(event: any, packet: ELynkPacket) {
        if (event.checked) {
            packet.add ??= new ELynkPacketAdd();
        } else {
            packet.add = null;
        }

        this._selectedPacket = packet;
    }

    clearPackets() {
        this.packets = [];
        this.selectedPacket = new ELynkPacket();
    }

    rowSelected() {
        this.selectedPacket = this.rowSelectedPacket
    }

    addPacket(event) {
        let addedPacket = new ELynkPacket();
        addedPacket.id = this.newPacketId;

        this.packets.push(addedPacket);

        this.newPacketId = '';
    }

    async deletePacketClick(packetId) {
        const response = await this.deletePacket(this.documentTypeId, packetId);

        if (+response.statusCode === 200) {
            const packetDeletedIndex = this.packets.findIndex(packet => packet.id === packetId);
            this.packets.splice(packetDeletedIndex, 1);
        }

        this.selectedPacket = new ELynkPacket();
    }

    async getPackets(documentTypeId: number): Promise<ELynkPacket[]> {
        const request = new GetElynkPacketsRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "elynk-packets-get", request) as GetElynkPacketsResponse;
        return response.packets ?? [];
    }

    private async deletePacket(documentTypeId: number, packetId: string): Promise<DeleteElynkPacketResponse> {
        const request = new DeleteElynkPacketRequest(documentTypeId, packetId);
        let response = await this.actionService.invoke(this.ActionType, "elynk-packet-delete", request) as DeleteElynkPacketResponse;
        return response;
    }
}
